import { AboutFourData } from "@/data";
import React from "react";
import Img from "./img";
import aboutShape from "@/images/shape/about-shape.png";
import SwiperCore, { Autoplay, EffectFade, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
SwiperCore.use([Autoplay, Navigation, EffectFade, Pagination]);

const AboutFour = () => {
  const { blockTitle } = AboutFourData;
  const { title, text1, text2 } = blockTitle;
  function createMarkup() {
    return { __html: title };
  }

  return (
    <section className="about_style_3_area section_padding">
      <div className="container">
        <div className="top_section">
          {/* <div className="col-md-6 col-sm-12"> */}
            <div className="about_image_box static"></div>
          {/* </div> */}

          {/* <div className="col-md-6 col-sm-12"> */}
            <div className="about_slider">
              <Swiper
                modules={[Autoplay]}
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                loop={true}
                className="mySwiper"
              >
                <SwiperSlide>
                  <div className="about_image_box about_image_box2"></div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="about_image_box about_image_box3"></div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="about_image_box about_image_box4"></div>
                </SwiperSlide>
              </Swiper>
            </div>
          {/* </div> */}
        </div>

        <div className="row bottom_section">
          <div className="col-md-4 col-sm-12">
            <div className="about_style_3_details">
              <h1 dangerouslySetInnerHTML={createMarkup()} />
            </div>
          </div>

          <div className="col-md-8 col-sm-12">
            <div className="about_style_3_details">
              <div className="about_us_shape">
                <Img src={aboutShape} alt="about shape" className="img-fluid" />
              </div>
              <p>{text1}</p>
            </div>
          </div>

          {/* <div className="col-md-4 col-sm-12">
            <div className="about_style_3_details">
              <p>{text2}</p>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default AboutFour;
